import { render } from "./SubcategoriesSkeleton.vue?vue&type=template&id=3867aa96&scoped=true"
import script from "./SubcategoriesSkeleton.vue?vue&type=script&lang=js"
export * from "./SubcategoriesSkeleton.vue?vue&type=script&lang=js"

import "./SubcategoriesSkeleton.vue?vue&type=style&index=0&id=3867aa96&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3867aa96"]])

export default __exports__